import React from 'react';
import Selectable from './Selectable';
import './SelectableImage.scss';

type SelectableImageProps = {
    onClicked: (selected: boolean) => void;
    name: string;
    selected: boolean;
    image: string;
    altText?: string;
    label?: string;
};

const SelectableImage = ({
    onClicked,
    name,
    selected,
    image,
    altText,
    label
}: SelectableImageProps): JSX.Element => {
    return (
        <div className='image-wrapper'>
            <Selectable
                id={`select${name}`}
                onClicked={(selected) => {
                    onClicked(selected);
                }}
                selected={selected}>
                <img
                    id={name}
                    src={image}
                    alt={altText}
                    className='select-image'
                />
                {label && <p>{label}</p>}
            </Selectable>
        </div>
    );
};

export default SelectableImage;
